import { useAwCacheKeyStore } from '~~/common/stores/awCacheKey';
import { useNuxtApp } from 'nuxt/app';

export function calculatePromotionPageHref (href: string, host: string) {
  let pageHref: string | undefined = href;

  //remove all query parameters
  pageHref = pageHref?.split('?')[0];

  //remove all hash parameters
  pageHref = pageHref?.split('#')[0];

  // remove host
  pageHref = pageHref?.replace(host, '');

  // remove protocol
  pageHref = pageHref?.replace(/^(https*:\/\/|\/\/)/, '');

  return pageHref;
}

export function calculatePromotionCompanyNo () {
  const awCacheKeyStore = useAwCacheKeyStore();
  return awCacheKeyStore.companyNo || awCacheKeyStore.cacheKeySegmentation.split('_')[0];
}

export function createHeaderIdFromToPath (toPath:string) {
  const { $router, $getHost } = useNuxtApp();
  const fromPath = calculatePromotionPageHref($router.currentRoute.value.fullPath, $getHost() || '');
  return createHeaderId(fromPath || '', calculatePromotionCompanyNo() || 'default', toPath);
}

export function createHeaderId (fromPath: string, companyNo:string, toPath:string) {
  return `[${fromPath}][${companyNo}][${toPath}]`;
}
